/**
 * 付费块解锁：真实 H5 走 /order 支付；编辑器 / mock 预览仍本地解锁
 */
import { GEDIT_GLOBAL_PAY_OID } from '../utils/geditPay.js';

export const geditPayUnlockMixin = {
	inject: {
		geditPay: {
			default: null,
		},
	},
	computed: {
		/** 模块 o_id：组件类型固定 id（H5 传 block.id） */
		geditPayModuleId() {
			return this.blockId || '';
		},
		isGeditRealPay() {
			return this.geditPay?.mode === 'real';
		},
		isGeditModulePaid() {
			const oId = this.geditPayModuleId;
			const paidModules = this.geditPay?.paidModules;
			if (!oId || !paidModules) return false;
			return Boolean(paidModules[oId]);
		},
		/** 是否应隐藏价格和按钮（由全局支付组件的 hideOtherPrice 配置控制） */
		shouldHidePrice() {
			return this.geditPay?.shouldHideOtherPrices === true;
		},
		/** @deprecated 兼容旧命名：按模块付费后不再表示整页 */
		isGeditPagePaid() {
			return this.isGeditModulePaid;
		},
	},
	watch: {
		isGeditModulePaid: {
			immediate: true,
			handler(paid) {
				if (paid && typeof this.unlockedLocal !== 'undefined') {
					this.unlockedLocal = true;
				}
			},
		},
	},
	methods: {
		/**
		 * @param {{ applyUnlock?: () => void }} [options]
		 */
		runGeditUnlockFlow({ applyUnlock } = {}) {
			if (this.editable) return;
			const finish = () => {
				applyUnlock?.();
			};
			if (!this.isGeditRealPay) {
				finish();
				return;
			}
			if (this.isGeditModulePaid) {
				finish();
				return;
			}
			const requestPay = this.geditPay?.requestPay;
			if (typeof requestPay !== 'function') return;
			// 全局支付开启了隐藏其他付费组件价格时，点击解锁应触发全局支付
			const oId = this.shouldHidePrice ? GEDIT_GLOBAL_PAY_OID : this.geditPayModuleId;
			if (!oId) return;
			Promise.resolve(requestPay(oId)).then((paid) => {
				if (paid) finish();
			}).catch(() => {});
		},
	},
};
